import { useState, useEffect } from 'react';
import { SessionManager } from './SessionManager';

export function useSession() {
	const [sessionId, setSessionId] = useState(SessionManager.getSessionId());
	const [metadata, setMetadata] = useState(SessionManager.getMetadata());
	const [isAuthenticated, setIsAuthenticated] = useState(SessionManager.isAuthenticated());

	useEffect(() => {
		const unsubscribe = SessionManager.onIdentityChange(() => {
			setSessionId(SessionManager.getSessionId());
			setMetadata(SessionManager.getMetadata());
			setIsAuthenticated(SessionManager.isAuthenticated());
		});
		return unsubscribe;
	}, []);

	return { sessionId, metadata, isAuthenticated };
}
